"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getResponseObject = getResponseObject;
exports.getConfigOptionObject = getConfigOptionObject;

function getResponseObject(type, data, hash) {
  const responseObject = {
    status: type,
    hash: hash || null,
    statusMsg: type === 'error' ? data.message || data : null,
    payload: type === 'success' ? data : null
  };
  return responseObject;
}

function getConfigOptionObject(data) {
  return {
    salt: data.promoVideoData.salt
  };
}